module.exports = __webpack_public_path__ + "static/media/help_hover.f3b7a256.png";